<ion-modal trigger="file-uploader-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ authenticator.user.username }}'s Photos</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="cancel()" [strong]="true">Close<ion-icon name="close"></ion-icon></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <div (click)="uploadImageClicked()" class="button-wrapper">
          <ion-button [disabled]="!isMainScene">
            <ion-label>Upload Image</ion-label>
            <ion-icon name="image-outline" slot="end"></ion-icon>
          </ion-button>
        </div>
      </ion-list>
      <ion-grid>
        <ion-row>
          <ion-col size="6" *ngFor="let photo of photos$ | async; index as position">
             <app-photo-container [privateDisplay]="true" [photoSrc]="photo.webviewPath" [filePath]="photo.filepath" ></app-photo-container>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ng-template>
</ion-modal>